import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { TimelineActiveFilterRegionEnum } from '@wilson/interfaces';

@Component({
  selector: 'wilson-clear-timeline-filters-button',
  templateUrl: './clear-timeline-filters-button.component.html',
  styleUrls: ['./clear-timeline-filters-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, NzButtonModule],
})
export class ClearTimelineFiltersButtonComponent implements OnInit {
  protected readonly router = inject(Router);
  protected readonly route = inject(ActivatedRoute);

  isFiltered$!: Observable<boolean>;
  renderUnmatchedElements = false;
  timelineActiveFilterRegion: TimelineActiveFilterRegionEnum[] = [];

  async resetAllQueryParams() {
    const keysToKeep = {
      renderUnmatchedElements: this.renderUnmatchedElements,
      timelineActiveFilterRegion: this.timelineActiveFilterRegion,
    };
    return this.router.navigate([], {
      relativeTo: this.route,
      queryParams: keysToKeep,
    });
  }

  ngOnInit(): void {
    this.isFiltered$ = this.route.queryParams.pipe(
      map((params) => {
        const {
          renderUnmatchedElements,
          timelineActiveFilterRegion,
          ...otherParams
        } = params;
        this.renderUnmatchedElements = renderUnmatchedElements;
        this.timelineActiveFilterRegion = timelineActiveFilterRegion;

        return Object.keys(otherParams).length > 0;
      }),
    );
  }
}
